export { SALUTATION, FIRST_NAME, LAST_NAME, EMAIL, STREET, POSTAL_CODE, CITY, COUNTRY } from "../_sub-forms/customer-data/field-names";
export var CUSTOMER = "customer";
export { NEWSLETTER } from "../_sub-forms/newsletter-agreement/field-names";
export var NEWSLETTER_AGREEMENT = "newsletter";
export { AGB, PRIVACY } from "../_sub-forms/legal-agreement/field-names";
export var LEGAL_AGREEMENT = "legal";
